import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#096dd9",
                secondary: "#4daef0",
                indigo: "#002766",
                warning: "#F59A23",
                teal: "#08c09e",
            },
        },
    },
});
